// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".setting-content-folder[data-v-35ffaae2] {\n  display: flex;\n  flex-direction: column;\n}\n.setting-content-folder .folder-icon[data-v-35ffaae2] {\n  margin-bottom: 20px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
